import { Container, Sprite } from "@pixi/react";
import React from "react";
import { useSelector } from "react-redux";
import { getNewUITexture } from "../../../../assets";
import { useDimensions } from "../../../../Contexts/DimensionsContext";
import { PixiSettings } from "../../../../pixiSettings";
import { useSecondaryToolbar } from "../../../../Hooks/useSecondaryToolbar";
import ButtonPlay from "../Buttons/ButtonPlay";
import ButtonHoldAndWinPlay from "../Buttons/ButtonHoldAndWinPlay";
import ButtonPotCollectionPlay from "../Buttons/ButtonPotCollectionPlay";
import FreeSpinButtonPlay from "../Buttons/FreeSpinButtonPlay";
import ButtonTurbo from "../Buttons/ButtonTurbo";

import ButtonAutoplay from "../Buttons/ButtonAutoplay";
import ButtonMaxBet from "../Buttons/ButtonMaxBet";
import ButtonBetSelect from "../Buttons/ButtonBetSelect";
import BalanceDisplay from "../Displays/BalanceDisplay";
import BetDisplay from "../Displays/BetDisplay";
import WinDisplay from "../Displays/WinDisplay";

import ButtonBonusBuy from "../Buttons/ButtonBonusBuy";
import {
  // selectHoldAndWinActive, // Griffin
  selectPotCollectionActive,
  selectFreeSpinsActive,
} from "../../../../State/selectors";
// Griffin's respins display — its context is gone (Cleopatra H&W is new).
// import RespinsDisplay from "../../shared/Displays/RespinsDisplay";
import { selectHoldAndWinActive as selectCleopatraHoldAndWinActive } from "../../../../State/Slices/holdAndWinSlice";
import { FEATURES_CONFIG } from "../../../../featuresConfig";

const ToolbarBottom = () => {
  const { dimensions, orientation } = useDimensions();

  // Use orientation-specific toolbar textures from new spritesheet
  const texture = orientation === PixiSettings.ORIENTATION.PORTRAIT
    ? getNewUITexture("toolbar gradient_portrait")
    : getNewUITexture("toolbar_gradient_landscape_half");

  // Get toolbar dimensions
  const toolbar = useSecondaryToolbar();

  // Check if HoldAndWin feature is active (Griffin — replaced below)
  // const holdAndWinActive = useSelector(selectHoldAndWinActive);

  // Check if PotCollection feature is active
  const potCollectionActive = useSelector(selectPotCollectionActive);

  // The Mad Labs free spins round. It swaps its own play button in, the same
  // way HoldAndWin and PotCollection do — only one play button is ever mounted.
  const freeSpinsActive = useSelector(selectFreeSpinsActive);

  // Cleopatra's Hold & Win room (its own slice). Checked FIRST: it can run
  // inside free spins, and then its button is the one that belongs on screen.
  const cleopatraHoldAndWinActive = useSelector(selectCleopatraHoldAndWinActive);


  return (
    <Container
      name="secondary_toolbar_bottom"
      x={(dimensions.width - toolbar.width) / 2}
      y={dimensions.height - toolbar.height}
      // Dev: invisible but in place (DEV_TOOLS.HIDE_UI).
      alpha={FEATURES_CONFIG.DEV_TOOLS.HIDE_UI ? 0.001 : 1}
    >
      {/* Background - spans full screen width, uses visualHeight (may extend above toolbar) */}
      <Sprite
        height={toolbar.visualHeight}
        texture={texture}
        width={dimensions.width}
        x={-(dimensions.width - toolbar.width) / 2}
        y={toolbar.height - toolbar.visualHeight}
      />

      <BalanceDisplay toolbar={toolbar} />
      <BetDisplay toolbar={toolbar} />
      <ButtonAutoplay toolbar={toolbar} />
      {FEATURES_CONFIG.BONUS_BUY.ENABLED && <ButtonBonusBuy toolbar={toolbar} />}
      {cleopatraHoldAndWinActive ? (
        <ButtonHoldAndWinPlay toolbar={toolbar} />
      ) : /* Griffin: FEATURES_CONFIG.HOLD_AND_WIN.ENABLED && holdAndWinActive ? (
        <>
          <RespinsDisplay toolbar={toolbar} />
          <ButtonHoldAndWinPlay toolbar={toolbar} />
        </>
      ) : */ FEATURES_CONFIG.POT_COLLECTION?.ENABLED && potCollectionActive ? (
        <ButtonPotCollectionPlay toolbar={toolbar} />
      ) : FEATURES_CONFIG.FREE_SPINS?.ENABLED && freeSpinsActive ? (
        <FreeSpinButtonPlay toolbar={toolbar} />
      ) : (
        <ButtonPlay toolbar={toolbar} />
      )}
      <ButtonTurbo toolbar={toolbar} />

      <ButtonMaxBet toolbar={toolbar} />
      <ButtonBetSelect toolbar={toolbar} />
      <WinDisplay toolbar={toolbar} />

    </Container>
  );
};

export default ToolbarBottom;
